@if (loadingState() === 'loading') {
  <p class="text-sm text-secondary m-0 p-4">Loading brief…</p>
} @else if (loadingState() === 'error') {
  <p class="text-sm text-red-600 m-0 p-4" role="alert">Failed to load brief.</p>
} @else if (brief(); as b) {
  <div
    class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-xl border border-zinc-200 shadow-sm dark:border-zinc-800 h-full">
    <div class="shrink-0 px-2 py-2 flex flex-row items-center justify-between drawer-header-primary">
      <div class="flex items-center gap-x-4 min-w-0">
        <div class="shrink-0 size-10 overflow-hidden rounded-lg bg-zinc-100 dark:bg-zinc-800">
          @if (b.businessAccount?.companyLogo) {
            <img
              [src]="imageService.getImageSource(b.businessAccount!.companyLogo, 'gallery')"
              alt=""
              class="size-full object-cover" />
          } @else {
            <div class="flex size-full items-center justify-center text-secondary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                aria-hidden="true">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <path d="M14 2v6h6" />
              </svg>
            </div>
          }
        </div>
        <div class="min-w-0">
          <h3 class="text-base font-semibold text-gray-900 dark:text-white m-0 truncate">
            {{ b.title }}
          </h3>
          <p class="text-sm text-gray-500 dark:text-gray-400 m-0 truncate">{{ briefSubtitle(b) }}</p>
        </div>
      </div>

      <nav aria-label="Brief insight sections" class="flex flex-row justify-end gap-x-2 shrink-0 overflow-x-auto">
        @for (item of navItems; track item.section) {
          <button
            type="button"
            class="inline-flex items-center border-b-2 px-2 py-2 text-sm font-medium whitespace-nowrap cursor-pointer bg-transparent"
            [class]="getNavClass(item)"
            (click)="goToSection(item)">
            {{ item.label }}
          </button>
        }
      </nav>
    </div>

    <div class="brief-insights-outlet-host p-2 scrollbar-transparent">
      <router-outlet />
    </div>
  </div>
}
